import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { IIo } from '../models/io';

@Injectable({
  providedIn: 'root',
})
export class Io {
  private baseUrl: string = `${environment.apiUrl}/controller`;
  private http: HttpClient = inject(HttpClient);

  //Signals for state
  ioInformation = signal<IIo | null>(null);
  ioRequired = computed(() => {
    const value = this.ioInformation();
    if (!value) {
      throw new Error('No ioInformation found!');
    }
    return value;
  });
  isLoading = signal(false);
  errorMessage = signal('');

  getIOInformation(controllerId: number): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http.get<IIo>(`${this.baseUrl}/${controllerId}/io`).subscribe({
      next: (data) => {
        this.ioInformation.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        console.log(err);
        this.errorMessage.set('Failed to load IOInformation');
        this.isLoading.set(false);
      },
    });
  }

  updateFromSocket(data: IIo) {
    this.ioInformation.set(data);
  }
}
